import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./button.css.ts.vanilla.css-mistica.js";
import "./button-layout.css.ts.vanilla.css-mistica.js";
var f = "kfxylhi", l = {
    right: "_1y2v1nfbf",
    left: "_1y2v1nfbd",
    center: "_1y2v1nfbe",
    "full-width": "kfxylhh _1y2v1nfbe"
}, i = "kfxylh6 _1y2v1nfb5", t = "kfxylh7", v = "kfxylh8", h = "kfxylh3 _1y2v1nfb5 _1y2v1nfbs", y = "kfxylh4", e = "kfxylh1", k = "kfxylh9", o = {
    buttonWidth: "var(--kfxylh0)"
};
export { f as alignMoreThanOneChildred, l as alignVariant, i as baseContainer, t as container, v as fullWidthContainer, h as link, y as linkAlignment, e as margins, k as noButtonWidth, o as vars };
